import { useWindowSize } from "utilities"

export const Rotator: React.FC<{
    settingsPortrait: boolean
    children(width: number, height: number): React.ReactNode
}> = ({ settingsPortrait, children }) => {
    const { width: screenWidth, height: screenHeight } = useWindowSize()
    const isPortrait = screenHeight > screenWidth

    const settingsMatchDeviceOrientation = settingsPortrait === isPortrait
    const needsRotation = settingsPortrait && !isPortrait

    return (
        <div
            style={
                needsRotation
                    ? {
                          transform: "rotate(90deg)",
                          transformOrigin: "bottom left",
                          position: "absolute",
                          top: "-100vw",
                          left: 0,
                          height: "100vw",
                          width: "100vh"
                      }
                    : { width: "100%" }
            }
        >
            {children(
                settingsMatchDeviceOrientation ? screenWidth : screenHeight,
                settingsMatchDeviceOrientation ? screenHeight : screenWidth
            )}
        </div>
    )
}
